<template>
  <div>
    <!-- <div class="color-tips" style="margin-left: 24px">
      {{ $t('colorPicker.gradient') }}
      <i>
        （{{ msgSplit(config.Extra.min, config.Extra.max) }}）
      </i>
    </div> -->
    <div class="color_pick_div">
      <span v-if="name && showLabel" class="scence_ctr_span_title">{{ name }}</span>
      <div
        v-for="(item, index) in config.Extra.max"
        :key="index"
        class="color-item"
        @mouseover="hoverIndex = index"
        @mouseleave="hoverIndex = null"
      >
        <div class="">
          <i
            v-if="hoverIndex === index && config.Extra.max > 1 && defaultColors[index] !== 0"
            class="close el-icon-close"
            @click.stop="deleteItem(index)"
          />
        </div>
        <ColorPicker
          :config="config.Extra"
          :matrix="config.Extra.matrix"
          :color="defaultColors[index]"
          :model="model"
          :is-single="false"
          @change="change($event, index)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ColorPicker from '@/components/deviceAction/colorPicker/main.vue';
import Clickoutside from 'element-ui/src/utils/clickoutside';
import { computedColors } from '@/utils/utils'


export default {
  components: {
    ColorPicker
  },
  directives: { Clickoutside },
  props: {
    model: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    // color:{
    //   required:true
    // }
  },
  data() {
    return {
      modelCopy: this.model,
      hoverIndex: null
    }
  },
  computed: {
    defaultColors() {
      let Result
      const max = this.config.Extra.max * 8
      if (this.modelCopy.DefaultValue && this.modelCopy.DefaultValue.length === max) {
        Result = computedColors(this.modelCopy.DefaultValue)
      } else {
        Result = computedColors('0'.repeat(this.config.Extra.max * 8))
      }
      return Result
    },
  },
  watch: {
    model: {
      handler(newVal) {
        this.modelCopy = newVal;
      },
      deep: true
    }
  },
  methods: {
    msgSplit(min, max) {
      // if (min === max) {
      //   return this.$t('colorPicker.gradientNum').replace(/\{\{min\}\}/, min)
      // } else {
      //   return this.$t('colorPicker.gradientNum').replace(/\{\{min\}\}/, min) + ','+ this.$t('colorPicker.gradientNum2').replace(/\{\{max\}\}/, max)
      // }
      return this.$t('colorPicker.gradientNum').replace(/\{\{min\}\}/, min);
    },
    deleteItem(index) {
      // 计算当前有效颜色数量(非0颜色)
      const validColors = this.defaultColors.filter(color => color !== 0).length;
      
      // 如果当前颜色数量等于最小要求,不允许删除
      if (validColors <= this.config.Extra.min) {
        this.$message({
          type: 'warning',
          message: this.msgSplit(this.config.Extra.min, this.config.Extra.max)
        });
        return;
      }
      this.defaultColors[index] = 0
      this.changeValue()
    },
    change(e, index) {
      try {
        this.defaultColors[index] = e
        this.changeValue()
      } catch (error) {
        console.log(error)
      }
    },
    changeValue() {
      try {
        const DefaultValue = this.defaultColors.reduce((sum, color) => {
          return sum + ('00000000' + color.toString(16)).slice(-8)
        }, '')
        this.modelCopy.DefaultValue = DefaultValue
        const defaultValueLen = this.defaultColors.filter(item => {
          return item !== 0
        })
        this.$emit('change', { value: DefaultValue, colorList: this.defaultColors, canChange: +this.config.Extra.min <= defaultValueLen.length })
      } catch (error) {
        console.log(error)
      }
    },
    getMaxArray() {
      return new Array(this.config.Extra.max).map((item, index) => {
        return index
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.color-item {
  position: relative;
  // float: left;
  margin-right: 5px;
}

.close {
  position: absolute;
  display: block;
  top: -10px;
  left: 0;
  z-index: 1003;
}

.el-icon-close::before {
  content: "\e6db" !important;
}

.el-icon-close {
  background: #2589FF;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  color: #fff !important;
}

.color-tips {
  color: #303030;
  line-height: 17px;
  margin-bottom: 10px;

  i {
    font-weight: 400;
    color: #999999;
    line-height: 14px;
  }
}

.scence_ctr_span {
  margin-left: 0px !important;
}
.color_pick_div{
  display: flex;
  
  flex-direction: row;
 
}
</style>